/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   useMountAndUnmount hook
 */

import { useEffect } from 'react'

interface Props {
  onMount?: () => void
  onUnmount?: () => void
}

export const useMountAndUnmount = ({ onMount, onUnmount }: Props) => {
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (onMount) {
      onMount()
    }

    return () => {
      if (onUnmount) {
        onUnmount()
      }
    }
  }, [])
  /* eslint-enable react-hooks/exhaustive-deps */
}
